import { useEffect } from 'react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';

import { isChunkLoadError, reloadForNewVersion } from '../app/chunkReload';

// Fehlergrenze für Routen: fängt Renderfehler ab, statt eine leere Seite zu zeigen.
export function RouteError() {
  const error = useRouteError();
  const newVersion = isChunkLoadError(error);
  useEffect(() => {
    if (newVersion) reloadForNewVersion();
  }, [newVersion]);
  const message = newVersion
    ? 'Maklerpass wurde gerade aktualisiert. Bitte die Seite neu laden, dann ist die neue Version da.'
    : isRouteErrorResponse(error)
      ? `${error.status} ${error.statusText}`
      : 'Beim Anzeigen dieser Seite ist ein unerwarteter Fehler aufgetreten.';
  return (
    <div className="center-page">
      <div className="alert alert-error error-message" role="alert">
        <strong>{newVersion ? 'Neue Version verfügbar' : 'Etwas ist schiefgelaufen'}</strong>
        <p>{message}</p>
        <div className="error-actions">
          <button type="button" className="btn" onClick={() => window.location.reload()}>
            Seite neu laden
          </button>
          <Link to="/">Zur Startseite</Link>
        </div>
      </div>
    </div>
  );
}

export function NotFoundPage({ message = 'Diese Seite gibt es nicht.' }: { message?: string }) {
  return (
    <div className="page">
      <h1>Nicht gefunden</h1>
      <p className="muted">{message}</p>
      <Link to="/">Zur Startseite</Link>
    </div>
  );
}
